const NOTICE_KEY = "milltech-essential-cookies-notice-v1";

export const legalLinks = () =>
  '<div class="legal-links"><a href="/legal/privacy.html" target="_blank" rel="noopener noreferrer">Privacy</a><a href="/legal/cookies.html" target="_blank" rel="noopener noreferrer">Cookies</a><a href="/legal/use.html" target="_blank" rel="noopener noreferrer">Use notice</a></div>';

function acknowledged() {
  try {
    return globalThis.localStorage?.getItem(NOTICE_KEY) === "seen";
  } catch {
    return false;
  }
}

export function cookieNotice() {
  if (acknowledged()) return "";
  return '<aside class="cookie-notice" aria-label="Cookie notice"><p>Milltech uses essential cookies for sign-in and security. We do not use advertising or analytics cookies. <a href="/legal/cookies.html" target="_blank" rel="noopener noreferrer">Cookie details</a></p><button type="button" data-cookie-notice-dismiss>Got it</button></aside>';
}

export function installCookieNotice(root = document) {
  root.addEventListener("click", (event) => {
    if (!event.target.closest?.("[data-cookie-notice-dismiss]")) return;
    try {
      globalThis.localStorage?.setItem(NOTICE_KEY, "seen");
    } catch {
      // The notice can still be dismissed for this page when storage is disabled.
    }
    root.querySelector(".cookie-notice")?.remove();
  });
}
